import * as React from "react";
import type { SVGProps } from "react";

const SvgCollectivesIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 24" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="m14 0 13.524 8.263a.989.989 0 0 1 .328 1.366 1 1 0 0 1-1.376.325L24 8.441V24H4V8.441L1.524 9.954a1 1 0 0 1-1.376-.325.989.989 0 0 1 .328-1.366Zm3.845 16.983L14 20.828l-3.846-3.845-.131.073a8.018 8.018 0 0 0-3.731 4.784L6.25 22h15.5l-.039-.154a8.016 8.016 0 0 0-3.73-4.79ZM14 2.331 6 7.219V18a10.03 10.03 0 0 1 4.335-3.307l.261-.1L14 18l3.406-3.405A10.025 10.025 0 0 1 22 18V7.219ZM14 6a4.001 4.001 0 0 1 .2 8H14a4.001 4.001 0 0 1-.2-8Zm0 2a2 2 0 1 0 2 2 2 2 0 0 0-2-2Z"
        />
    </svg>
);
export default SvgCollectivesIcon;
